var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"MyIndex_box3_inner"}},[_c('img',{attrs:{"src":this.imgUrls[0],"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }